"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PreviewSidebarAsync;

var _AsyncComponent = _interopRequireDefault(require("customer-data-ui-utilities/component/AsyncComponent"));

var _react = _interopRequireDefault(require("react"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

function requirement(done) {
  import(
  /* webpackChunkName: "preview-sidebar" */
  'crm_ui/sidebar/PreviewSidebar').then(function (mod) {
    return mod.default;
  }).then(done, (0, _AsyncComponentErrorHandler.default)('preview-sidebar'));
}

function PreviewSidebarAsync(props) {
  return _react.default.createElement(_AsyncComponent.default, {
    props: props,
    requirement: requirement
  });
}

module.exports = exports.default;